import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable, Subject, Subscription, throwError} from 'rxjs';
import {finalize, map} from 'rxjs/operators';
import {v4 as uuidv4} from 'uuid';

import {LOCALSTORAGE_KEY_AUTH} from '../../defines/client.const';
import {CONTENT_TYPE_JSON_UTF8, USER_LOGIN_API_URL, USER_REGISTER_API_URL} from '../../defines/protocol';
import {GenPassword, IsEmptyString} from '../../defines/common.func';
import {ApiService} from '../api/api.service';


@Injectable({
  providedIn: 'root'
})
export class UserService {
  private userid: string | null = null;
  private password: string | null = null;
  public get UserId(): string | null {
    return this.userid;
  }

  private awt: string | null = null;
  public get Token(): string | null {
    // console.log('UserService::Token = ', this.awt);
    return this.awt;
  }

  private login$: BehaviorSubject<boolean> | null = null;
  private isLoggingin = false;
  private isRegistering = false;
  private register$: Subscription | null = null;
  private sendingToken = false;


  constructor(
    private api: ApiService,
  ) {
    this.load();
  }

  public Login(resetToken: boolean = false): Observable<boolean> {
    // console.warn('UserService::Login()');
    if (resetToken) {
      this.awt = null;
    }

    if (this.login$) {
      return this.login$.asObservable();
    }

    if (IsEmptyString(this.userid)) {
      this.login$ = new BehaviorSubject<boolean>(false);
      this.register().pipe(
        finalize(() => this.login$ = null)
      ).subscribe(this.login$);
      return this.login$.asObservable();
    }
    else if (IsEmptyString(this.awt)) {
      this.login$ = new BehaviorSubject<boolean>(false);
      this.login().pipe(
        finalize(() => this.login$ = null)
      ).subscribe(this.login$);
      return this.login$.asObservable();
    }
    else {
      this.RetrySendToken().subscribe(
        () => console.log('sendFcmToken success'),
        err => console.warn('sendFcmToken failure', err)
      );
      return new Observable<boolean>(observer => {
        observer.next(true);
        observer.complete();
      });
    }
  }


  private login(): Observable<boolean> {
    // console.warn('UserService::login()');
    if (this.isLoggingin) {
      console.warn('login is already running!');
      return throwError({detail: 'login is already running'});
    }
    this.isLoggingin = true;
    const url = USER_LOGIN_API_URL;

    return this.api.Post(url,
      {
        user_id: this.userid,
        password: this.password,
      },
      null,
      CONTENT_TYPE_JSON_UTF8).pipe(
        finalize(() => this.isLoggingin = false),
        map((data: {token: string}) => {
          if ('token' in data) {
            this.awt = data.token;

            this.save();
            return true;
          }
          return false;
        })
    );
  }


  private register(): Observable<boolean> {
    // console.warn('UserService::register()');
    if (this.isRegistering) {
      console.warn('user register is already running!');
      return throwError({detail: 'user register is already running'});
    }
    this.isRegistering = true;

    const url = USER_REGISTER_API_URL;
    this.userid = uuidv4();
    this.password = GenPassword(20);


    return this.api.Post(url,
      {
        user_id: this.userid,
        password: this.password,
      },
      null,
      CONTENT_TYPE_JSON_UTF8).pipe(
        finalize(() => this.isRegistering = false),
        map((data: {token: string}) => {
            console.log('data = ', data);
            if ('token' in data) {
              this.awt = data.token;

              this.save();
              return true;
            }
            return false;
          })
        );
  }

  public RetrySendToken(): Observable<boolean> {
    if (this.sendingToken) {
      console.warn('RetrySendToken() already sending');
      return throwError({msg: 'already senging'});
    }
    this.sendingToken = true;

    return new Observable<boolean>(observer => {
      // let count = 5;
      // const hInterval = setInterval(() => {
      //   console.log('RetrySendToken count=', count);
      //   if (--count < 0) {
      //     clearInterval(hInterval);
      //     observer.error('send fcm token failure');
      //   }
      //   else if (!IsEmptyString(this.Token) &&
      //     !IsEmptyString(this.fcm.token) &&
      //     !IsEmptyString(device.platform) && device.platform !== 'null')
      //   {
      //     console.warn('RetrySendToken() awt token =', this.Token);
      //     this.fcm.SendFcmToken(this.fcm.token,
      //       device.platform.toLowerCase() as PLATFORM_TYPE,
      //       device.model)
      //       .subscribe(() => {
      //           observer.next(true);
      //           observer.complete();
      //         },
      //         err => {
      //           observer.error(err);
      //         }
      //       );
      //     clearInterval(hInterval);
      //   }
      // }, 1000);
      observer.next(true);
      observer.complete();
    }).pipe(
      finalize(() => this.sendingToken = false)
    );
  }

  toJSON(): any {
    return {
      userid:   this.userid,
      password: this.password,
      token:    this.awt,
    };
  }

  public load(): void {
    const txtAuth = localStorage.getItem(LOCALSTORAGE_KEY_AUTH);
    const auth = txtAuth ? JSON.parse(txtAuth) : null;

    this.userid     = (auth && auth.userid) ?? null;
    this.password   = (auth && auth.password) ?? null;
    this.awt        = (auth && auth.token) ?? null;

    console.log('UserService::load()', this);
  }

  public save(): void {
    localStorage.setItem(LOCALSTORAGE_KEY_AUTH, JSON.stringify(this));
  }
}
